import {ReactReduxContext, useDispatch} from 'react-redux';
import {cleanStep3, setCurrentStep, setFormData, setStep4Housing} from '../../actions';
import FormStep from '.';
import React, {useContext, useEffect, useState} from "react";
import StartOverButton from '../startOverButton';
import {createSelector} from "reselect";
import AutoHeader from '../autoHeader';
import {Step4DropDown} from "../step4DropDown";


import {RESIDENCY_CALIFORNIA, STATUS_INDEPENDENT} from "./bi/constants/MAGIC_NUMBERS";
import {AidPanel} from "../aidPanel";
import {CheckStep4} from "../aidPanel/GetCosts";
import {StepIndicator} from "../stepIndicator";

const Step4 = () => {
    const cs4 = CheckStep4();

    const dispatch = useDispatch();
    const context = useContext(ReactReduxContext);
    const formData = context.store.getState().app.stepData;

    const residentHeading = cs4.residency_value === RESIDENCY_CALIFORNIA
        ? "California Resident"
        : "Nonresident";

    const dependencyStatus = (parseInt(formData.step1.status) === STATUS_INDEPENDENT)
        ? "Independent"
        : "Dependent";

    //  This allows step4 to present itself without getting put into an infinite loop
    //  displaying <Step4 />
    useEffect(() => {
        dispatch(setFormData(4, {backup2: formData.step2}));
        dispatch(cleanStep3());
    }, []);

    const stepCampus = state => state.step2.campus;
    const stepHousing = state => state.step2.housing;

    const selectAidData = createSelector(
        [stepCampus, stepHousing], (c, h) =>
        {return {housing: h, campus: c};
        });

//    const ch = selectAidData(formData);

    const [aidData, setAidData] = useState({
        housing: formData.step2.housing,
        campus: formData.step2.campus
    });

    const handleRecalculateClick = (e) => {
        e.preventDefault();
        setAidData({housing: formData.step2.housing,campus: formData.step2.campus});
    }

    return (
        <FormStep>
            <div id="step-4">
                <AutoHeader text="Financial Aid Estimator" />
                <StepIndicator title="Final Results" previous={false}/>

                <div id="step-results" className="section-results fae-section-content">
                    <h2 className="info-title">{residentHeading} &ndash; {dependencyStatus}</h2>
                    <div>
                        You may adjust your selected campus and housing type
                        if desired. Clicking 'Recalculate' will display
                        adjusted results. Clicking 'start over' will clear
                        your entry and bring you back to Step 1.
                    </div>
                    <div id="step-results-campus-housing">
                        <Step4DropDown
                            elementName="campus"
                            dataSource="campusList"
                            labelText="Selected Campus"
                            value={formData.step4.backup2.campus}
                        />
                        <Step4DropDown
                            elementName="housing"
                            dataSource="housingList"
                            labelText="Housing Type"
                            value={formData.step4.backup2.housing}
                        />
                    </div>

                    <AidPanel recalculateData={aidData}/>
                    <div id="step-result-buttonbox" style={{display: "flex", flexDirection: "row"}}>
                        <div style={{marginRight: "1rem"}}>
                            <button id="step-result-button" onClick={handleRecalculateClick}>Recalculate</button>
                        </div>
                    </div>

                </div>
            </div>
        </FormStep>
    )
}

/**
 * A Redux thunk function that recalculates step 4 housing data
 *
 * @returns {Function} A thunk function that receives `dispatch` and `getState` as arguments
 */
const Step4RecalculateThunk = () => {
    return function (dispatch, getState) {
        const tmpHousing = getState().app.stepData.step2;
        dispatch(setStep4Housing(tmpHousing));
        dispatch(setCurrentStep(4));
    }
};


export default Step4;
